import React, { Component } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CTextarea,
  CCardFooter,
  CInput,
  CSpinner,
  CTooltip,
  CFormGroup,
  CLabel,
  CSelect,
  CRow,
  CCol,
  CCollapse
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { Input } from "reactstrap";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import SelectModal from "../CommunityModal/selectResourceMethod";
import EducationPlanCard from "../EducationPlanCard";
import Loading from "../Loading";

class CommunityContentNotices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      publishLoading: false,
      plans: null,
      // tab: 1,
      // title: "",
      observation: "",
      other_resources: "",
      other_methods: "",
      evaluation: "",
      selectModal: false,
      selectedResources: [],
      selectedMethods: [],
      // roles: [],
      // selectedRoles: "Todos",
      classes: 1,
      classDates: [],
      series: [],
      serie_id: 0,
      periods: [],
      period_id: 0,
      curricula: [],
      curriculum_id: null,
      showCreate: false
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.handlePlans();

    axios
      .get(`${URL.api}education/period/list`, {
        params: { group_id: this.props.room?.room?.group_id },
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState({
              periods: resp.data.data
            });
          } else {
            toastr.error("Erro", "Não foi possível carregar os períodos.");
          }
        },
        () => {
          toastr.error("Erro", "Não foi possível carregar os períodos.");
        }
      );

    axios
      .get(`${URL.api}classification/serie/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            if (this.props.general.active_roles.type === "P") {
              const roomUser = this.props.room?.room_user.find(
                item => item.user_id === this.props.user.user.id
              );
              const roomDisciplines = this.props.room?.room_user_discipline
                .filter(item => item.room_user_id === roomUser?.id)
                .map(item => item.room_discipline_id);
              const series = this.props.room?.room_discipline
                .filter(item => roomDisciplines.includes(item.id))
                .map(item => item.serie_id);
              const uniqueSeries = [...new Set(series)];

              this.setState({
                series: resp.data.data.filter(item =>
                  uniqueSeries.includes(item.id)
                )
              });
            } else {
              this.setState({
                series: resp.data.data
              });
            }
          } else {
            toastr.error("Erro", "Não foi possível carregar as séries.");
          }
        },
        () => {
          toastr.error("Erro", "Não foi possível carregar as séries.");
        }
      );
  }

  handlePlans() {
    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}education/plan/list`, {
        params: { room_id: id, user_id: this.props.user.user.id },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            plans: resp.data.data,
            loading: false,
            observation: "",
            other_methods: "",
            other_resources: "",
            evaluation: "",
            // deleteModal: false,
            deleteId: null,
            selectedResources: [],
            selectedMethods: [],
            classDates: [],
            classes: 1,
            curriculum_id: null,
            serie_id: 0,
            period_id: 0
          });
        },
        error => {
          this.error("Não foi possível carregar os planos de ensino.");
        }
      );
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  insertPlan() {
    this.setState({ publishLoading: true });

    const obj = {
      curriculum_id: this.state.curriculum_id,
      user_id: this.props.user.user.id,
      observation: this.state.observation,
      other_methods: this.state.other_methods,
      other_resources: this.state.other_resources,
      evaluation: this.state.evaluation,
      dates: this.state.classDates,
      resources: this.state.selectedResources.map(item => ({
        resource_id: item.id,
        observation: null
      })),
      methods: this.state.selectedMethods.map(item => ({
        method_id: item.id,
        observation: null
      })),
      room_id: this.props.room?.room?.id
    };

    if (!obj.curriculum_id) {
      toastr.error("Erro", "Escolha um currículo.");
      this.setState({ publishLoading: false });
      return;
    }

    axios
      .post(`${URL.api}education/plan/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ publishLoading: false, showCreate: false });
          this.handlePlans();
        },
        error => {
          this.error(error.response.statusText);
          this.setState({ publishLoading: false });
        }
      );
  }

  deleteNotice() {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ deleteModal: false });
    axios
      .post(
        `${URL.api}communication/notice/delete/${this.state.deleteId}`,
        null,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          if (resp.data.success === false) {
            this.error(resp.data.error);
          } else {
            this.handlePlans();
          }
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  closeModal(item, type) {
    if (item) {
      if (type === "resource") {
        this.setState(state => {
          const newList = state.selectedResources.filter(
            resource => item.id !== resource.id
          );
          newList.push(item);

          return { selectedResources: newList };
        });
      } else {
        this.setState(state => {
          const newList = state.selectedMethods.filter(
            method => item.id !== method.id
          );
          newList.push(item);

          return { selectedMethods: newList };
        });
      }
    }

    this.setState({ selectModal: false });
  }

  removeSelectedResource(resource) {
    this.setState(state => {
      const newList = state.selectedResources.filter(
        item => item.id !== resource.id
      );

      return { selectedResources: newList };
    });
  }

  removeSelectedMethod(method) {
    this.setState(state => {
      const newList = state.selectedMethods.filter(
        item => item.id !== method.id
      );

      return { selectedMethods: newList };
    });
  }

  changeSerie(serie) {
    this.setState(
      {
        serie_id: parseInt(serie)
      },
      this.handleCurricula()
    );
  }

  changePeriod(period) {
    this.setState(
      {
        period_id: parseInt(period)
      },
      () => this.handleCurricula()
    );
  }

  handleCurricula() {
    if (!this.state.serie_id || !this.state.period_id) {
      return;
    }

    axios
      .get(`${URL.api}education/curriculum/list`, {
        params: {
          serie_id: this.state.serie_id,
          period_id: this.state.period_id
        },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState({
              curricula: resp.data.data
            });
          } else {
            this.error("Erro ao carregar currículos.");
          }
        },
        error => {
          this.error("Erro ao carregar currículos.");
        }
      );
  }

  render() {
    const { id } = this.props.match.params;

    const curriculum = this.state.curricula.find(
      item => item.id === parseInt(this.state.curriculum_id)
    );

    const plans = this.state.plans?.filter(
      plan =>
        plan.observation
          ?.toLowerCase()
          .includes(this.props.search.toLowerCase()) ||
        `${plan.curriculum?.ability?.description} - ${plan.curriculum?.ability?.code}`
          .toLowerCase()
          .includes(this.props.search.toLowerCase())
    );

    return (
      <>
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <React.Fragment>
            {this.state.selectModal && (
              <SelectModal
                room={id}
                group={this.props.room?.room?.group_id}
                onClose={(selected, type) => this.closeModal(selected, type)}
                isRoom={this.props.isRoom}
              />
            )}
            {this.props.hasPrivilege && (
              <>
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="m-0">Criar plano de ensino</h4>
                  <CButton
                    onClick={() =>
                      this.setState(state => ({
                        showCreate: !state.showCreate
                      }))
                    }
                    className={`activity-collapse cursor fa ${
                      this.state.showCreate ? "fa-chevron-up" : "fa-plus"
                    }`}
                  />
                </div>
                <hr style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }} />
                <CCollapse show={this.state.showCreate}>
                  <CCard>
                    <CCardBody>
                      <CFormGroup>
                        <CRow>
                          <CCol>
                            <CLabel>Série</CLabel>
                            <CSelect
                              value={this.state.serie_id}
                              onChange={e => this.changeSerie(e.target.value)}
                            >
                              <option value="0">Série</option>
                              {this.state.series.map(item => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </CSelect>
                          </CCol>
                          <CCol>
                            <CLabel>Período</CLabel>
                            <CSelect
                              value={this.state.period_id}
                              onChange={e => this.changePeriod(e.target.value)}
                            >
                              <option value="0">Período</option>
                              {this.state.periods.map(item => (
                                <option key={item.id} value={item.id}>
                                  {item.description}
                                </option>
                              ))}
                            </CSelect>
                          </CCol>
                        </CRow>
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Currículo</CLabel>
                        <Select
                          placeholder="Currículo"
                          name="Currículo"
                          options={this.state.curricula.map(item => ({
                            value: item.id,
                            label: item.code
                          }))}
                          value={
                            curriculum
                              ? { value: curriculum.id, label: curriculum.code }
                              : null
                          }
                          noOptionsMessage={() => "Nada encontrado"}
                          className="basic-multi-select flex-1"
                          classNamePrefix="select"
                          onChange={e =>
                            this.setState({ curriculum_id: e.value })
                          }
                        />
                      </CFormGroup>
                      {curriculum && (
                        <div
                          className="pl-3"
                          style={{ borderLeft: "4px solid var(--light)" }}
                        >
                          <CFormGroup>
                            <CLabel>Habilidade</CLabel>
                            <div className="text-muted">
                              {curriculum.ability?.description
                                ? `(${curriculum.ability.code}) ${curriculum.ability.description}`
                                : "-"}
                            </div>
                          </CFormGroup>
                          <CFormGroup>
                            <CLabel>Observação</CLabel>
                            <div className="text-muted">
                              {curriculum.observation || "-"}
                            </div>
                          </CFormGroup>
                        </div>
                      )}
                      <CFormGroup>
                        <CLabel>Número de aulas</CLabel>
                        <Input
                          type="number"
                          min="1"
                          max="100"
                          value={this.state.classes}
                          onChange={e =>
                            this.setState({ classes: parseInt(e.target.value) })
                          }
                        />
                      </CFormGroup>
                      {this.state.classes > 0 &&
                        new Array(this.state.classes)
                          .fill(0)
                          .map((item, index) => (
                            <CFormGroup>
                              <CLabel>{index + 1}ª aula</CLabel>
                              <CInput
                                type="date"
                                value={this.state.classDates[index]}
                                onChange={e => {
                                  // eslint-disable-next-line react/no-access-state-in-setstate
                                  const newDates = this.state.classDates;
                                  newDates[index] = e.target.value;
                                  this.setState({ classDates: newDates });
                                }}
                              />
                            </CFormGroup>
                          ))}
                      <CFormGroup>
                        <CLabel>Métodos e recursos</CLabel>
                        <div
                          className="d-flex align-items-center"
                          style={{ flex: 1, flexWrap: "wrap" }}
                        >
                          <CTooltip content="Adicionar método ou recurso">
                            <div
                              className="c-avatar mr-2 btn-light cursor  mb-1"
                              onClick={() =>
                                this.setState({ selectModal: true })
                              }
                            >
                              <i className="fa fa-plus text-muted"></i>
                            </div>
                          </CTooltip>
                          {this.state.selectedResources.map(resource => (
                            <div
                              className="c-avatar mr-2 bg-primary cursor position-relative px-3 w-auto mb-1"
                              key={resource.id}
                            >
                              <i className="fa fa-puzzle-piece mr-2"></i>
                              {resource.description}
                              <div
                                className="text-white ml-2"
                                onClick={() =>
                                  this.removeSelectedResource(resource)
                                }
                              >
                                <i className="fa fa-close"></i>
                              </div>
                            </div>
                          ))}
                          {this.state.selectedMethods.map(method => (
                            <div
                              className="c-avatar mr-2 bg-warning cursor position-relative px-3 w-auto mb-1"
                              key={method.id}
                            >
                              <i className="fa fa-gears mr-2"></i>
                              {method.description}
                              <div
                                className="text-white ml-2"
                                onClick={() =>
                                  this.removeSelectedMethod(method)
                                }
                              >
                                <i className="fa fa-close"></i>
                              </div>
                            </div>
                          ))}
                        </div>
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Outros métodos</CLabel>
                        <CTextarea
                          value={this.state.other_methods}
                          onChange={e =>
                            this.setState({ other_methods: e.target.value })
                          }
                          placeholder="Escreva outros métodos"
                          rows={3}
                        />
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Outros recursos</CLabel>
                        <CTextarea
                          value={this.state.other_resources}
                          onChange={e =>
                            this.setState({ other_resources: e.target.value })
                          }
                          placeholder="Escreva outros recursos"
                          rows={3}
                        />
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Avaliação</CLabel>
                        <CTextarea
                          value={this.state.evaluation}
                          onChange={e =>
                            this.setState({ evaluation: e.target.value })
                          }
                          placeholder="Escreva a avaliação"
                          rows={3}
                        />
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Observação</CLabel>
                        <CTextarea
                          value={this.state.observation}
                          onChange={e =>
                            this.setState({ observation: e.target.value })
                          }
                          placeholder="Escreva uma observação"
                          rows={3}
                        />
                      </CFormGroup>
                    </CCardBody>
                    <CCardFooter className="d-flex justify-content-end">
                      <div className="d-flex align-items-center">
                        <CButton
                          color="primary"
                          onClick={() => this.insertPlan()}
                          style={{ position: "relative" }}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <span
                            style={
                              this.state.publishLoading ? { opacity: 0 } : null
                            }
                          >
                            Salvar
                          </span>
                          {this.state.publishLoading && (
                            <CSpinner
                              color="white"
                              size="sm"
                              style={{ position: "absolute" }}
                            />
                          )}
                        </CButton>
                      </div>
                    </CCardFooter>
                  </CCard>
                </CCollapse>
              </>
            )}
            {plans && plans.length > 0 ? (
              <React.Fragment>
                {plans.map(plan => (
                  <EducationPlanCard
                    plan={plan}
                    onReload={() => this.handlePlans()}
                  />
                ))}
              </React.Fragment>
            ) : (
              <div className="d-flex align-items-center justify-content-center m-3">
                Nenhum plano de ensino encontrado
              </div>
            )}
          </React.Fragment>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentNotices);
